import url from './api_backend_url.json'

export default url
